/**
 * Component Registry for Lineups Inc Theme
 * 
 * Extends the base vibeoff-base theme registry with Lineups Inc specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-vibeoff-base/registry';

/**
 * Lineups Inc specific component overrides.
 * These components have been customized for the Lineups Inc brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const lineupsincOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const lineupsincOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Lineups Inc properties.
 * Inherits all components from the vibeoff-base theme, with Lineups Inc overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...lineupsincOverrides,
};

export default registry;
